import { Currency } from '../types/api.types';

const EXCHANGE_RATE_CACHE_KEY = 'expat-exchange-rates';
const CACHE_DURATION_HOURS = 24;

export interface ExchangeRates extends Record<Currency, number> {
    USD: number;
    INR: number;
    CAD: number;
}

const DEFAULT_RATES: ExchangeRates = {
    USD: 1,
    INR: 96.82,
    CAD: 1.37,
};

export async function getExchangeRates(): Promise<ExchangeRates> {
    const cached = localStorage.getItem(EXCHANGE_RATE_CACHE_KEY);

    if (cached) {
        const { rates, timestamp } = JSON.parse(cached);
        const ageHours = (Date.now() - timestamp) / (1000 * 60 * 60);
        if (ageHours < CACHE_DURATION_HOURS) {
            return rates;
        }
    }

    try {
        const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
        const data = await res.json();
        const rates: ExchangeRates = {
            USD: 1,
            INR: data.rates.INR,
            CAD: data.rates.CAD,
        };

        localStorage.setItem(EXCHANGE_RATE_CACHE_KEY, JSON.stringify({ rates, timestamp: Date.now() }));

        return rates;
    } catch (error) {
        console.error('Failed to fetch exchange rates:', error);
        return DEFAULT_RATES;
    }
}
